import { Button, Modal, Form, Input } from 'antd';
import React, { useEffect } from 'react'; // Added useEffect
import PropTypes from "prop-types";
import { addReferDoctor, deleteReferDoctor, updatereferDoctor, updateReferDoctor } from '../../services/doctor/referDoctor/referDoctor'; // Assuming updateReferDoctor exists
import { useMessageApi } from '../../services/message api/MessageProvider';
import { useAuth } from '../../services/authentication_API/authService';
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";


const AddReferModal = ({ show, handleClose, editData }) => {
  const [form] = Form.useForm();
  const messageApi = useMessageApi();
  const {userData}=useAuth()

  // Determine if we are in Edit mode
  const isEditMode = !!editData;
  const modalTitle = isEditMode ? 'Edit Refer Doctor' : 'Add New Refer';

  // --- EFFECT TO HANDLE EDIT DATA POPULATION ---
  useEffect(() => {
    if (show && isEditMode && editData) {
      // Set the form fields when in edit mode and the modal opens
      form.setFieldsValue(editData);
    } else if (show && !isEditMode) {
      // Clear the form fields when in Add mode and the modal opens
      form.resetFields();
    }
  }, [show, isEditMode, editData, form]);

  const handleModalCancel = () => {
    form.resetFields();
    handleClose();
  };
  
  const validateRequiredFields = () => {
    return form
      .validateFields()
      .then(() => true)
      .catch(() => false);
  };
  
  const handleModalSave = async () => {
    if (await validateRequiredFields()) {
      try {
        const values = form.getFieldsValue();
        let result;

        if (isEditMode) {
          // UPDATE LOGIC: Include the doctor's ID for the update API call
          const updatePayload = {
            doctor_id:userData?.id,
            id: editData.id, // Assuming the ID is named 'id'
            ...values,
          };
          result = await updatereferDoctor(editData.id,updatePayload); // Placeholder API call
        } else {
          // ADD LOGIC
          result = await addReferDoctor(values);
        }

        if (result?.success) {
          messageApi.success(`Refer Doctor ${isEditMode ? 'updated' : 'added'} successfully!`);
          console.log('Result data:', result?.data);
          handleClose(result?.data);
        } else {
          const errors = result?.error;
          Object.entries(errors).forEach(([field, messages]) => {
            const messageArray = Array.isArray(messages) ? messages : [messages];
            messageArray.forEach((msg) => {
              messageApi.error({
                content: `${field}: ${msg}`,
                style: { maxWidth: "300px", minWidth: "300px", textAlign: "left", wordBreak: "break-word" },
              });
            });
          });
        }
      } catch (error) {
        messageApi.error(`Failed to ${isEditMode ? 'update' : 'add'} refer doctor.`);
      }
    }
  };
  const handleDelete = async () => {

    let result;

    try {
        result = await deleteReferDoctor(editData.id);

      if (result?.success) {
        messageApi.success("Refer Doctor deleted successfully!");
        handleClose(result?.data);
      } else {
        messageApi.error(result.error || "Something went wrong while deleting.");
      }
    } catch (error) {
      messageApi.error("Submission failed");
    }
  }

  return (
    <>
      <Modal
        title={
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            {modalTitle} {/* Dynamic Title */}
          </div>
        }
        open={show}
        maskClosable={false} 
        keyboard={false}
        onOk={handleModalSave}
        onCancel={handleModalCancel}
        footer={[
          editData &&(<Button
            key="delete"
            icon={
              <DeleteOutlined
                style={{
                  fontSize: "150%", // Use a percentage of the container's font size
                }}
              />
            }
            style={{ color: "#ff4d4f" }}
            onClick={() => {
              handleModalCancel(), handleDelete();
            }}
          ></Button>),
          <Button key="cancel" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleModalSave}>
            {isEditMode ? "Update" : "Save"} {/* Dynamic Button Text */}
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" name="add_new_refer_form">
          {/* Form Items remain the same, just ensure names match API payload fields */}
          <Form.Item
            label="Doctor Name"
            name="doctor_name"
            rules={[
              { required: true, message: "Please input the Doctor Name!" },
            ]}
          >
            <Input placeholder="Doctor Name" />
          </Form.Item>
          <Form.Item label="Mobile Number" name="mobile_numer">
            <Input placeholder="Mobile Number" />
          </Form.Item>
          <Form.Item label="Clinic Number" name="clinic_numer">
            <Input placeholder="Clinic Number" />
          </Form.Item>
          <Form.Item label="Clinic Address" name="clinic_address">
            <Input placeholder="Clinic Address" />
          </Form.Item>
          <Form.Item label="Speciality" name="speciality">
            <Input placeholder="Speciality" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

AddReferModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  editData: PropTypes.object, // New prop for holding edit data
  // Removed unused props: patientName, patientMobile, editpatientsdetail
};

export default AddReferModal;